import PageGroupActions from '../actions/PageGroupCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy, retrievedAll, update, localBatchUpdate } from './common/commonReducers';

const initialState = {
  busy: false,
  entities: [],
};

export default function pageGroup(state = initialState, action) {
  switch (action.type) {
    case PageGroupActions.busyAction: return setBusy(state);
    case PageGroupActions.retrievedAllAction: return retrievedAll(state, action);
    case PageGroupActions.updateAction:return update(state, action);
    case PageGroupActions.localBatchUpdateAction: return localBatchUpdate(state, action);
    case Actions.RESET: return initialState;
    case Actions.UNBUSY: return setUnBusy(state);
    default: return state;
  }
}
